// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

export const categories = {
  aps: {
    name: "Agendar Consulta",
    comment:
      "Serviços de cuidados essenciais para a saúde como: Sintomas e queixas de saúde, Consulta de rotina, Dúvidas e outros.",
    hasHelp: true,
  },
  ocp: {
    name: "Exames Ocupacionais",
    comment:
      "Exames médicos para avaliação da saúde dos trabalhadores como: Periódico, Admissional, Demissional, Retorno ao trabalho entre outros.",
    hasHelp: false,
  },
  mv: {
    name: "Mapa da vida",
    comment:
      "Orientação individual sobre o mapa da vida, entrar em rodas de conversa do seu interesse e demais ações para cuidar da pessoa mais importante da vida: você.",
    hasHelp: false,
  },
  "pbh-documentais": {
    name: "Perícias documentais",
    comment: "Perícia realizada, exclusivamente, em documentos de saúde.",
    hasHelp: false,
  },
};
